/** 包装清单特殊配置 */

/** 自定义行数据信息
 * masterPic: 主图
 */
export const customRowConfig = {
  // X3鬼灭弥豆子版本(无内存卡) 中国大陆
  2358: {
    zh_cn: {
      masterPic: 'https://res.insta360.com/static/77eb3d6fe6cabe676e2774b76e77632c/01.png',
    },
  },
  // X3鬼灭弥豆子版本(64G内存卡) 中国大陆
  2359: {
    zh_cn: {
      masterPic:
        'https://res.insta360.com/static/6821bd8deaac6638edb12178c874d5f8/%E7%A5%A2%E8%B1%86%E5%AD%90-%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9064G.png',
    },
  },
  // X3鬼灭弥豆子版本(128G内存卡) 中国大陆
  2360: {
    zh_cn: {
      masterPic:
        'https://res.insta360.com/static/bd9ccb2c60bbf692c262d9f29e3fb099/%E7%A5%A2%E8%B1%86%E5%AD%90-%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90128G.png',
    },
  },
  // X3鬼灭炭治郎版本(无内存卡) 中国大陆
  2361: {
    zh_cn: {
      masterPic: 'https://res.insta360.com/static/41f280dc5ebab8c1f8c2bba8fe5cdce7/01.png',
    },
  },
  // X3鬼灭炭治郎版本(64G内存卡) 中国大陆
  2362: {
    zh_cn: {
      masterPic:
        'https://res.insta360.com/static/84f451a268bf616a2e2328a2271129e9/%E7%82%AD%E6%B2%BB%E9%83%8E-%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9064G.png',
    },
  },
  // X3鬼灭炭治郎版本(128G内存卡) 中国大陆
  2363: {
    zh_cn: {
      masterPic:
        'https://res.insta360.com/static/1c0b881360b93af4c1dd11a7db8f8a80/%E7%82%AD%E6%B2%BB%E9%83%8E-%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90128G.png',
    },
  },
};

/** 自定义列数据信息
 * masterPic: 主图
 */
export const customColConfig = {
  194: {
    zh_cn: {
      masterPic: 'https://res.insta360.com/static/41f280dc5ebab8c1f8c2bba8fe5cdce7/01.png',
    },
  },
  195: {
    zh_cn: {
      masterPic: 'https://res.insta360.com/static/77eb3d6fe6cabe676e2774b76e77632c/01.png',
    },
  },
};
